import React, { useMemo, useState, useEffect } from "react";
import { Grid,Tooltip } from "@mui/material";
import Helmet from "react-helmet";
import { pageStore } from "../../common";
import {  useStatePtr } from "@pure-ptr/react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
    createStringDataField,
    createTimestampField,
   createStatusField

} from "../../util/format";
import { StringEquators,dateEquators,BooleanEquators,integerEquators } from "../../store/constants/pages";
import {
    Portlet,
    PortletBody,
    PortletHeader,
} from "../../partials/content/Portlet";

import { resetPage, set, auditLogsLanding } from "../../store/actions/pages";
import { PagedTable } from "../../common";
import { DateRange, getToday } from "../../util/date";
import { DateRangePicker } from "../../common/dateRangeControl";
import { setMulti } from "../../store/actions/pages";
import { getDatePtrInitialValue } from "../../util/date";
import { RootState } from "../../store/reducers";
import TrailLogsEventArguments from "./TrailLogsEventArguments";
import { selectAllClientListTiny } from "../../store/selectors/clients";


const { usePageStore, useGridFilters } = pageStore("audit-logs-landing", {});
const DEFAULT_HIDDEN_FIELDS = [];
const DEFAULT_SORT = [{ id: 'time', orderBy: 'desc' }];

const statusDropdownOptions = [
    {
        label: 'Success',
        value: 'Success'
    },
    {
        label: 'Failed',
        value: 'Failed'
    },
];

export const TrailLogsPage = () => {
    const [refresh, setRefresh] = useState(Promise.resolve());
    const filters: any = useSelector<RootState>(
        (state) => state?.pages?.["audit-logs-landing"]
    );
    const clients =useSelector(selectAllClientListTiny)
    const appliedFilters=filters?.filter
    
    const dispatch = useDispatch();

    const dateRangePtr = useStatePtr<DateRange>(
        getDatePtrInitialValue(appliedFilters?.length > 0 ? appliedFilters : null, getToday)
    ),dateRange = dateRangePtr.value;

    useEffect(() => {
        const initialFromFilter = getDatePtrInitialValue(appliedFilters?.length > 0 ? appliedFilters : null, getToday);
        if (
            initialFromFilter.startdate !== dateRange.startdate || 
            initialFromFilter.enddate !== dateRange.enddate
        ) {
            dateRangePtr.set(initialFromFilter);
        }
    }, [appliedFilters]);

    useEffect(() => {
        dispatch(set("audit-logs-landing", "audit-logs-range", dateRange));
    }, [dateRange, dispatch]);

    const trailLogsData = usePageStore((s) => {
        return s.list;
    });

    const pending = usePageStore((s) => s.pending);

    function handleRefresh() {
        dispatch(set("audit-logs-landing", "list", []));
        setRefresh(Promise.resolve());
    }

    useEffect(() => {
        const pageName = { name: "audit-logs-landing" };
        dispatch(set(pageName.name, "waitForCriteriaFilter", false));
    }, [dispatch]);

    const dateFilterArray = (startDate, endDate) => [
        {
            id: "time",
            equator: "greater_than_or_equals_to",
            value: startDate,
            hiddenFromFilterPanel:true
        },
        {
            id: "time",
            equator: "less_than_or_equals_to",
            value: endDate,
            hiddenFromFilterPanel:true
        },
    ];

    return (
        <>
            <Helmet title="Audit Logs" />
            <Portlet>
                <PortletHeader
                    title={"Audit Logs"}
                    name="audit-logs-landing"
                    showSearchFilters={true}
                    showSearchFiltersDropdown={false}
                    handleRefresh={handleRefresh}
                    // toolbar={<></>}
                />
                <PortletBody>
                    <Grid container >
                    <Grid item xs={6} md={3} lg={2}>
                    <DateRangePicker
                        // disableDateSection={true}
                        disabled={false}
                        enabledSwitch={false}
                        valuePtr={{
                            ...dateRangePtr,
                            set: (value) => {
                                dateRangePtr.set(value);

                                dispatch(
                                    setMulti("audit-logs-landing", {
                                        'audit-logs-range': value,
                                        filter: [...(appliedFilters?.filter((item)=>!item?.hiddenFromFilterPanel) || []),...(dateFilterArray(
                                            value.startdate,
                                            value.enddate
                                        ) || [])],
                                    })
                                );
                                handleRefresh();
                            },
                        }}
                        label="Date Range"
                    />
                    </Grid>
                    </Grid>


                    <TrailLogsDataGrid
                        loading={pending}
                        data={trailLogsData}
                        selected={[]}
                        refresh={refresh}
                        dispatch={dispatch}
                        clients={clients}
                    />
                </PortletBody>
            </Portlet>
        </>
    );
};

const TrailLogsDataGrid = ({
    refresh,
    data,
    loading,
    dispatch,
    selected,
    clients
}) => {

    const fields = useMemo(
        () => [

            createStringDataField("clientId", "Client Id", {
                sortable: true,
                equators: integerEquators,
                width:"60px"
            }),
            createStringDataField("clientName", "Client Name", {
                sortable: false,
                isDropdown:true,
                dropdownValues:clients?.map((item)=>(item?.name)) ?? [],
                equators: BooleanEquators,
                width:"120px"
            }),
            createTimestampField('time', 'Date', { sortable: true, equators: dateEquators, width:"140px" }),
            createStringDataField("itemname", "Item Name", {
                sortable: true,
                default: true,
                equators: StringEquators,
                secondLevel: "name",
                width:"150px"
            }),
             createStringDataField("userName", "User Name", {
                sortable: true,
                default: true,
                equators: StringEquators,
                secondLevel: "name",
                width:"200px"
            }),

            createStringDataField("eventType", "Event Type", {
                sortable: true,
                equators: StringEquators,
                width:"150px"
            }),
            createStringDataField("eventSource", "Event Source", {
                sortable: true,
                equators: StringEquators,
                width:"150px"
            }),
            //  createStringDataFieldwithEllipis('eventArguments', 'Event Arguments',{width:"300px",wordBreak:"break-word",hideFromFilter:true}),
             createStringDataField('eventDetails', 'Event Details',{width:"400px",wordBreak:"break-word",hideFromFilter:true}),
            createStatusField('status', 'Status', { equators: BooleanEquators, returnWholeRow: true, isStrictDropdown: true, dropdownValues: statusDropdownOptions,sortable:true })
           
        ],
        []
    );

        function trailLogsRowLevelActions(rowData) {
            return (
                <>             
                    {rowData?.eventArguments && <Grid item>
                        <Tooltip title="Process Claim">
                           <TrailLogsEventArguments rowData={rowData}/>
                        </Tooltip>
                    </Grid>}
                </>
            );
        }
    

    const tableFilter = useGridFilters();

    return (
        <>
        <PagedTable
            name="audit-logs-landing"
            fields={fields}
            loading={loading}
            data={data || []}
            paginationFilters={tableFilter}
            onLoad={(sort, filter, pagination) => {
                dispatch(
                    auditLogsLanding(
                        pagination,
                        sort,
                        filter
                        
                    )
                );
            }}
            selectedIdsPtr={selected}
            refresh={refresh}
            defaultSort={DEFAULT_SORT}
            criteriasSaveEnabled={true}
            showSearchFilters={true}
            defaultHiddenFields={DEFAULT_HIDDEN_FIELDS}
            hasActions={true}
            customActionColumnName="Event Arguments"
            shouldRenderLazy={true}
            renderActionColumn={trailLogsRowLevelActions}

        />
        </>
    );
};